module.exports = __webpack_public_path__ + "img/sycamore-device.fc397ecd.png";